import React, { useEffect } from "react";
import { AuthProvider } from "react-admin";
import { Typography } from "@material-ui/core";
import LoginLayout from "./LoginLayout";

interface IProps {
  authProvider: AuthProvider;
}

const Login = (props: IProps & any) => {
  useEffect(() => {
    props.authProvider.login(null);
  }, [props.authProvider]);

  return (
    <LoginLayout>
      <Typography variant="body1">Redirecting to login...</Typography>
    </LoginLayout>
  );
};

export default Login;
